import { IncExcKeyWrapper, IncExcKeyCriteria, BasicScenario } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';
import { ExternalAPI } from '../../model/external-api';
import { IncExcKeyVO } from '../../vo/core/incexckey.vo';
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';

/**
 * chargement des clés include / exclude
 * Author LMA
 */
export class IncExKeyCmd extends WizCommand<IncExcKeyWrapper> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  } 
  
  
  /** retourne un wrapper pre-alimenté */
  public wrapper(): IncExcKeyWrapper {
    const wrapper: IncExcKeyWrapper = new IncExcKeyWrapper();
    wrapper.criteria = new IncExcKeyCriteria();
    wrapper.criteria.manageDeprecated = true;
    wrapper.criteria.manageDeleted = true;
    wrapper.criteria.domain = this.model.domainCode;
    wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
    wrapper.scenario = new BasicScenario();
    wrapper.scenario.languageCode = this.model.currentLocaleCode;
    return wrapper;
  }


  /** chargement initial. Toute la BU */
  public find(): IncExKeyCmd {
    const wrapper: IncExcKeyWrapper = this.wrapper();
    wrapper.method = WIZ_COMMAND_METHOD.FIND;
    this.configureRemote(ExternalAPI.INCEXCKEY_API, wrapper);
    return this;
  }

  /** sur retour, traitement selon la méthode */
  public wizResult() {
    super.wizResult();
    // Initialisation du model
    const incexcList: IncExcKeyVO[] = this.result.entities.map((incexc) => new IncExcKeyVO(this.model, incexc));
    this.model.incExcKeyEngine.buildMap(incexcList);
  }

}
